import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TmsLogService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getTmsLog(gridData, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/tms-log/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
